module.exports = __webpack_public_path__ + "components/flag/static/square/bs-303ea1707c314d951be311480abfe381.svg";